// removed by extract-text-webpack-plugin
module.exports = {"accordion":"accordion-module__accordion___3je77","listItem":"accordion-module__listItem___2HKAD","headlineContainer":"accordion-module__headlineContainer___3FAeb","active":"accordion-module__active___3aQcr","headline":"accordion-module__headline___LvJLE","headlineImageContainer":"accordion-module__headlineImageContainer___1BLFu","noIcon":"accordion-module__noIcon___2FSjW","transparentSpace":"accordion-module__transparentSpace___2X9gM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/accordion/accordion.module.scss
// module id = 252
// module chunks = 0